import {createSlice} from '@reduxjs/toolkit';

const initialState = {
  id: '',
  name: '',
  nodes: [],
  edges: [],
  trace: {},
  createdAt: '',
  updatedAt: '',
  unsavedChanges: false,
};

const caseSlice = createSlice({
  name: 'case',
  initialState,
  reducers: {
    setCaseAndTrace: (state, action) => {
      return {
        ...action.payload,
        unsavedChanges: false,
      };
    },
    setCase: (state, action) => {
      return {
        ...action.payload,
        unsavedChanges: false,
        trace: {}
      };
    },
    setTrace: (state, action) => {
      return {
        ...state,

        trace: action.payload
      };
    },
    colorNode: (state, action) => {
      const colors = {
        'red': -1,
        'white': 0,
        'green': 1,
        'loading': 2
      };

      const {nodeId, color, microserviceId, fetcherName, url, info, ts} = action.payload;
      if (!state.trace[nodeId]) state.trace[nodeId] = {};
      if (!state.trace[nodeId][microserviceId]) state.trace[nodeId][microserviceId] = {};
      if (!state.trace[nodeId][microserviceId][fetcherName]) state.trace[nodeId][microserviceId][fetcherName] = {};

      state.trace[nodeId][microserviceId][fetcherName] = {
        url: url,
        run: colors[color],
        info: info,
        ts: ts
      };
    },
    colorDefault: (state, action) => {
      const {nodeId, microserviceId, fetcherName, url} = action.payload;
      if (!state.trace[nodeId]) state.trace[nodeId] = {};
      if (!state.trace[nodeId][microserviceId]) state.trace[nodeId][microserviceId] = {};
      if (!state.trace[nodeId][microserviceId][fetcherName]) state.trace[nodeId][microserviceId][fetcherName] = {
        url: url,
        run: 0,
        info: 'Not executed',
        ts: 0
      };
    },
    clearCase: () => {
      return initialState;
    },
    setUnsavedChanges: (state, action) => {
      return {
        ...state,
        unsavedChanges: action.payload
      };
    }
  }
});

const {setCaseAndTrace, setCase, setTrace, colorNode, colorDefault, clearCase, setUnsavedChanges} = caseSlice.actions;

const caseReducer = caseSlice.reducer;

const selectId = (state) => state.case.id;
const selectName = (state) => state.case.name;
const selectNodes = (state) => state.case.nodes;
const selectEdges = (state) => state.case.edges;
const selectTrace = (state) => state.case.trace;
const selectCreatedAt = (state) => state.case.createdAt;
const selectUpdatedAt = (state) => state.case.updatedAt;
const selectCase = (state) => state.case;
const selectUnsavedChanges = (state) => state.case.unsavedChanges;

export {
  setCaseAndTrace,
  setCase,
  setTrace,
  colorNode,
  colorDefault,
  clearCase,
  setUnsavedChanges,
  caseReducer,
  selectId,
  selectName,
  selectNodes,
  selectEdges,
  selectTrace,
  selectCreatedAt,
  selectUpdatedAt,
  selectCase,
  selectUnsavedChanges
};